import React from 'react';
import SectionHeader from './SectionHeader';

export default function ChapterCard({ data, plates, meta, paragraphs, quote, compact, showStatus }) {
  return (
    <section id={data.chapter.replace(/\s+/g, '-').toLowerCase()} className={`section-pad ${compact ? 'py-24' : ''}`}>
      <div className="container-narrow">
        <SectionHeader chapter={data.chapter} label={data.label} heading={data.heading} />
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8">
            {paragraphs ? (
              paragraphs.map((p, i) => (
                <p key={i} className="font-serif text-[18px] md:text-[19px] leading-[1.75] text-[color:var(--bx-bone)]/85 mb-5">
                  {p}
                </p>
              ))
            ) : (
              <p className="font-serif text-[19px] md:text-[20px] leading-[1.75] text-[color:var(--bx-bone)]/85">{data.body}</p>
            )}
            {(quote || data.quote) && (
              <p className="lead-quote font-serif italic text-2xl md:text-[28px] mt-8">{quote || data.quote}</p>
            )}
            {showStatus && data.status && (
              <div className="mt-10 inline-flex items-center gap-4 px-5 py-3 border border-[color:var(--bx-gold)]/30 bg-black/30">
                <span className="bullet-mark" />
                <span className="font-sc text-[11px] gold-text tracking-[0.4em]">{data.status}</span>
              </div>
            )}
          </div>
          <div className="lg:col-span-4">
            {meta && (
              <div className="space-y-5">
                {meta.map((m, i) => (
                  <div key={i} className="border-l border-[color:var(--bx-gold)]/30 pl-4">
                    <div className="font-sc text-[10px] gold-text tracking-[0.4em] mb-1">{m.k}</div>
                    <div className="font-serif text-[17px] text-[color:var(--bx-bone)]/85">{m.v}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {plates && plates.length > 0 && (
          <div className="mt-16 grid grid-cols-1 gap-8 max-w-5xl mx-auto">
            {plates.map((pl, i) => (
              <div key={i} className="plate w-full" style={{ aspectRatio: "21 / 9" }}>
                <img src={pl.img} alt={pl.title} loading="lazy" />
                <div className="plate-meta">
                  <div>
                    <div className="font-sc text-[10px] gold-text tracking-[0.4em]">{pl.n}</div>
                    <div className="font-sc text-[10px] text-[color:var(--bx-bone)]/80 tracking-[0.32em] mt-1">{pl.title}</div>
                  </div>
                  <div className="font-mono text-[10px] text-[color:var(--bx-muted)]">21 : 9</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
